import * as Yup from 'yup';

export const DealStatusFormValidationSchema = Yup.object().shape({
  code: Yup.string().required('errors.required'),
  is_active: Yup.bool().oneOf([false, true]).required('errors.required'),
  name: Yup.string().required('errors.required'),
});
